// useMillNames.js
import { useState, useEffect } from "react";

export default function useMillNames() {
  const [millDetailsList, setMillDetailsList] = useState([]);

  useEffect(() => {
    async function fetchMillNames() {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/mills`, {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        });
        const data = await response.json();

        if (data) {
          // Format the data as needed
          const formattedData = data.map(element => ({
            ...element,
            value: element.millName,
            label: element.millName,
          }));

          setMillDetailsList(formattedData);
        } else {
          console.warn("Mill details data is not available.");
        }
      } catch (error) {
        console.error("Error fetching mill names:", error);
      }
    }

    fetchMillNames();
  }, []);

  return millDetailsList;
}
